interface FilterOption {
  value: string;
  label: string;
  count?: number;
}

interface FilterGroupProps {
  title: string;
  icon?: string;
  options: FilterOption[];
  selected: string[];
  onToggle: (value: string) => void;
  single?: boolean;
}

export default function FilterGroup({
  title,
  icon,
  options,
  selected,
  onToggle,
  single = false,
}: FilterGroupProps) {
  return (
    <div className="border-b border-background-200 pb-4 last:border-b-0 last:pb-0">
      <h3 className="mb-2.5 flex items-center gap-1.5 font-label text-sm font-medium text-foreground-900">
        {icon ? <i className={icon} aria-hidden="true"></i> : null}
        {title}
      </h3>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = selected.includes(option.value);
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onToggle(option.value)}
              aria-pressed={active}
              className={`inline-flex items-center gap-1 rounded-md border px-2.5 py-1.5 font-label text-xs transition-colors ${
                active
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {option.label}
              {typeof option.count === "number" ? (
                <span className={active ? "text-background-50/70" : "text-foreground-400"}>
                  {option.count}
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
      {single ? <p className="mt-2 font-label text-[11px] text-foreground-400">单选，点击切换</p> : null}
    </div>
  );
}